<unity-page-container [contentHeader]="contentHeader" [isLoading]="false">
  <kendo-stacklayout orientation="vertical" class="not-found-container" [align]="{ horizontal: 'center', vertical: 'middle' }">
    <kendo-card class="not-found-card">
      <kendo-card-header>
        <h1>Page Not Found!</h1>
      </kendo-card-header>
      <kendo-card-body>
        <h4>The page you're looking for may have been moved or no longer exists.</h4>
        <p>
          Please use the navigation menu to find what you need. If you cannot find the page you are looking for, contact support for
          assistance.
        </p>
        <button type="button" kendoButton themeColor="base" (click)="return()">Return To Previous Page</button>
      </kendo-card-body>
    </kendo-card>
  </kendo-stacklayout>
</unity-page-container>
